
import './ConfigureCms.scss';

import React, { ChangeEvent, FC, useState } from 'react';
import { CmsConnection } from 'models/CmsConnection';
import { CmsConnectionType } from 'models/CmsConnectionType';
import { Col, Form, Row } from 'react-bootstrap';

import { WizardStepInfo } from '../SetupWizard/WizardStepInfo';
import WizardActions from '../WizardActions/WizardActions';


interface ConfigureCmsProps extends WizardStepInfo {
  cachedCmsConnection: CmsConnection;
  onUpdate: (entity: string, key: string, value: any) => void;
}

const ConfigureCms: FC<ConfigureCmsProps> = ({
  cachedCmsConnection,
  onUpdate,
  ...wizardContext
}) => {
  const [isNoneSelected, setIsNoneSelected] = useState(false);

  const onEntityFieldChange = (event: ChangeEvent<HTMLInputElement | HTMLSelectElement | any>) => {
    onUpdate('CmsConnection', event.target.name, event.target.value);

    if (event.target.name === 'connectionType' && event.target.value === CmsConnectionType.None) {
      setIsNoneSelected(true);
    } else {
      setIsNoneSelected(false);
    }
  };
  const [validated, setValidated] = useState(false);
  // eslint-disable-next-line consistent-return
  const onFormValidated = (validationResult: boolean): number | void => {
    setValidated(validationResult);

    if (cachedCmsConnection.connectionType === CmsConnectionType.None) {
      return 5;
    }
    
  };
  const modifiedWizardContext = { ...wizardContext, onFormValidated };

  return (
    <div className="ConfigureCms">
      <h1 className="wizard-title text-center">Configure Your CMS</h1>
      <Form validated={validated} noValidate>
        <Form.Group as={Row} controlId="connectionType" className="mb-4">
          <Form.Label column sm={2}>
            CMS Connection Type
          </Form.Label>
          <Col sm={10}>
            <Form.Select
              aria-label="Cms Connection Type"
              value={cachedCmsConnection.connectionType}
              onChange={onEntityFieldChange}
              name="connectionType"
              tabIndex={1}
              required
            >
              <option value="">Select your CMS</option>
              <option value="WordPress">WordPress</option>
              <option value="BlabberJax">BlabberJax CMS (requires CMS subscription)</option>
              <option value="None">None</option>
            </Form.Select>
            <Form.Text muted>
              Don&#39;t see your CMS listed?  Request it {" "}
              <a href="https://airtable.com/appETyqdO92stApnJ/shrk15GxrWTOrqySX" target="_blank" rel="noreferrer">here</a>!
            </Form.Text>
            <Form.Control.Feedback type="invalid">
              Please select your type of CMS
            </Form.Control.Feedback>
          </Col>
        </Form.Group>
        <Form.Group as={Row} controlId="Username" className="mb-4">
          <Form.Label column sm={2}>
            Username
          </Form.Label>
          <Col sm={10}>
            <Form.Control
              type="text"
              value={cachedCmsConnection.username || ''}
              onChange={onEntityFieldChange}
              aria-label="Wordpress Username"
              name="username"
              placeholder="Wordpress Username"
              className="form-control"
              tabIndex={2}
              required={!isNoneSelected}
            />
            <Form.Control.Feedback type="invalid">
              Please enter your {cachedCmsConnection.connectionType} username.
            </Form.Control.Feedback>
            <Form.Control.Feedback type="invalid">
              Please enter a valid username
            </Form.Control.Feedback>
          </Col>
        </Form.Group>
        <Form.Group as={Row} controlId="applicationPassword" className="mb-4">
          <Form.Label column sm={2}>
            Application Password
          </Form.Label>
          <Col sm={10}>
            <Form.Control
              type="password"
              value={cachedCmsConnection.applicationPassword || ''}
              onChange={onEntityFieldChange}
              aria-label="Application Password"
              name="applicationPassword"
              autoComplete="organization"
              placeholder="Secret"
              className="form-control"
              tabIndex={3}
              required={!isNoneSelected}
            />
            <Form.Text muted>
              Please generate an application password to authenticate to your{' '}
              {cachedCmsConnection.connectionType} site. For help setting up an application
              password, follow{' '}
              <a href="https://blabberjax.atlassian.net/wiki/spaces/BKP/pages/423756199/How+to+Create+an+Application+Password+for+WordPress" target='_blank' rel="noreferrer">
                this guide
              </a>
              .
            </Form.Text>
            <Form.Control.Feedback type="invalid">
              Please enter your application password
            </Form.Control.Feedback>
          </Col>
        </Form.Group>
        <WizardActions {...modifiedWizardContext} />
      </Form>
    </div>
  );
};

export default ConfigureCms;
